export const PAYMENTS_METHODS = {
  SBP: 'SBP',
  CARD: 'CARD',
  PAYMENTS_ACCOUNT: 'PAYMENTS_ACCOUNT',
  PARTNER_ACCOUNT: 'PARTNER_ACCOUNT',
} as const;

export const PAYMENTS_METHODS_ICON = {
  SBP: 'sbp',
  CARD: 'credit-card',
  PAYMENTS_ACCOUNT: 'file-text',
  PARTNER_ACCOUNT: 'wallet',
} as const;

export const PARTNER_ACCOUNT_PAYMENT_METHOD_ID = 4;

export const PAYMENTS_METHODS_MOCK = [
  // { type: PAYMENTS_METHODS.SBP, name: 'СБП', id: 1, icon: 'svg' },
  { type: PAYMENTS_METHODS.CARD, name: 'Картой', id: 2, icon: 'credit-card' },
  {
    type: PAYMENTS_METHODS.PAYMENTS_ACCOUNT,
    name: 'По счёту',
    id: 3,
    icon: 'file-text',
  },
];

export const PARTNER_PAYMENTS_METHODS = [
  {
    type: PAYMENTS_METHODS.PARTNER_ACCOUNT,
    name: 'Партнёрский счёт',
    id: PARTNER_ACCOUNT_PAYMENT_METHOD_ID,
    icon: 'wallet',
  },
];

export const MAP_PAYMENTS_METHODS_TYPE_TO_I18_KEY = {
  SBP: 'billing:payment.paymentMethods.sbp',
  CARD: 'billing:payment.paymentMethods.card',
  PAYMENTS_ACCOUNT: 'billing:payment.paymentMethods.paymentsAccount',
  PARTNER_ACCOUNT: 'billing:payment.paymentMethods.partnerAccount',
} as const;
